import signalConfig from '../constants/signalConfig';
import humanizeString from 'humanize-string';
import * as signalNames from './../constants/signalNames';
import * as signalTypes from './../constants/signalTypes';

export const getSignalName = (type) => {
  const config = signalConfig[type.toLowerCase()];
  if (config) {
    return config.title;
  }
  return humanizeString(type);
};

export const getSignalSubtitle = (flattenSignal) => {
  const config = signalConfig[flattenSignal.signalKey.toLowerCase()];

  const description =
    flattenSignal.description ||
    flattenSignal.details.description ||
    (flattenSignal.pages ? flattenSignal.pages[0].description : '');

  return config.getDescription
    ? config.getDescription(flattenSignal)
    : humanizeString(description);
};

/**
 * This function returns an unique string that identifies an instance of a Signal
 * This can be used to identify a specific instance (e.g. tooltips, hide on hover, etc...)
 * The way it works is that i creates a base64 string of the bounding boxes of the instance, which is the differentiator for each instance
 * it takes than the last 20 characters of the base 64 and removes any trailing =, plus it adds the x0 and top values to make sure it results with an unique ID
 */
export const getInstanceId = (
  instance,
  pageNumber,
  signalKey,
  boundingBoxId = 0,
) => {
  const baseObject = { bounding_boxes: instance.bounding_boxes };
  const instanceStringStringified = btoa(encodeURI(JSON.stringify(baseObject)));
  const instanceString = instanceStringStringified
    .substring(
      instanceStringStringified.length - 20,
      instanceStringStringified.length,
    )
    .replace(/=/g, '');
  return `instance-id-${signalKey}-${instanceString}-${pageNumber}-${
    instance.bounding_boxes?.length
      ? `${parseInt(instance?.bounding_boxes[boundingBoxId].x0)}-${parseInt(
          instance.bounding_boxes[boundingBoxId].top,
        )}`
      : ''
  }`;
};

export const getSignalLink = (signal, options) => {
  const { signalKey, type, page_number, documents } = signal;

  let signalParts = {
    name: 'document-signals',
    query: { page_number },
  };

  if (signalKey === signalNames.SEEN_BEFORE) {
    signalParts = {
      name: 'document-seen-before',
      params: { previousDocuments: documents },
    };
  }

  if (
    signalKey === signalNames.COPYCAT_TEXT &&
    typeof documents !== 'undefined' &&
    documents.length > 0
  ) {
    signalParts = {
      name: 'document-copycat-text',
      params: { previousDocuments: documents },
    };
  }

  if (signalKey === signalNames.XRAY) {
    signalParts = { name: 'document-recovered' };
  }

  if (signalKey === signalNames.TEMPLATES) {
    signalParts = { name: 'matching-template' };
  }

  if (type === signalTypes.METADATA) {
    signalParts = { name: 'document-metadata', query: { signal: signalKey } };
  }

  if (type === signalTypes.CUSTOM_RULE) {
    signalParts = { name: 'rules-settings-view' };
  }

  if (
    [signalNames.BLOCKLISTS, signalNames.REJECTED_CUSTOMER].includes(signalKey)
  ) {
    signalParts = { name: 'document-databases', query: { signal: signalKey } };
  }

  const { name, params, query } = signalParts;
  return {
    name,
    params: {
      customer_id: options.customer_id,
      document_id: options.document_id,
      ...params,
    },
    query: {
      ...options.query,
      ...query,
    },
  };
};
